import React, { useState } from 'react';
import { useTooltip } from '@nivo/tooltip';
import colors from '../../../../../../constants/colors';
import Translator from '../../../../../components/helpers/Translator';

const RiskCellComponent = ({ cell }, riskMatrix) => {
  const { showTooltipFromEvent, hideTooltip } = useTooltip();
  const [riskNumber] = useState(riskMatrix?.[cell?.data?.x]?.[cell?.serieId]);

  const handleMouseEnter = (e) => {
    showTooltipFromEvent(
      <div
        style={{
          padding: '10px',
          background: 'black',
          color: 'white',
          borderRadius: '4px',
        }}
      >
        <strong>Riesgo:</strong>{' '}
        <Translator file="filter" name={`filter.probability.${riskNumber}.m`} /><br />
        <strong><Translator file="module-intelligence" name="obligations" />:</strong>{' '}{cell?.data?.y}
      </div>,
      e
    );
  };

  const handleMouseLeave = () => {
    hideTooltip();
  };

  return (
    <g
      transform={`translate(${cell?.x}, ${cell?.y})`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <circle r="26.55" fill={colors?.probSevRisk?.[riskNumber]} />
      <text
        textAnchor="middle"
        alignmentBaseline="central"
        fill="white"
        fontSize={10}
      >
        {cell?.data?.y}
      </text>
    </g>
  );
};

export default RiskCellComponent;
